import Vue from 'vue'
import urls from '../services.url.js'
import authHeaders from './headers'

export default {
  bulkPublishPlayerUograde (playerUpgradeArray) {
    let body = JSON.stringify(playerUpgradeArray)
    return Vue.http.patch(urls.PLAYER_UPGRADE_BULK_PUBLISH_ROOT, body, {'headers': authHeaders.getAuthHeaders()})
  },
  bulkCreatePlayerUpgrade (playerUpgradeArray) {
    let body = JSON.stringify(playerUpgradeArray)
    return Vue.http.post(urls.PLAYER_UPGRADE_ROOT, body, {'headers': authHeaders.getAuthHeaders()})
  },
  getPlayerUpgradeForPlayer (playerId) {
    let target = urls.PLAYER_UPGRADE_ROOT + '?player=' + playerId
    return Vue.http.get(target)
  },
  getUpgradeToBeDoneForPlayer (playerId) {
    let target = urls.PLAYER_UPGRADE_ROOT + '?player=' + playerId + '&status=0'
    return Vue.http.get(target)
  },
  bulkPublishBaseUpgrade (upgrades) {
    var target = urls.PUBLISH_BASE_UPGRADES
    let body = JSON.stringify(upgrades)
    return Vue.http.post(target, body, {'headers': authHeaders.getAuthHeaders()})
  }
}



// WEBPACK FOOTER //
// ./src/api/real-api/player-upgrade.api.js